import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router, IsActiveMatchOptions } from "@angular/router";


export interface SingleMenuItemProps{
  name: string;
  icon: string;
  url?: string;
}

@Component({
  selector: 'app-single-menu-item',
  templateUrl: './single-menu-item.html',
  styleUrls: ['./single-menu-item.scss'],
  standalone: false
})
export class SingleMenuItem {
  @Input({ required: true }) item!: SingleMenuItemProps;
  @Output() onClick = new EventEmitter<void>();

  private readonly routerOptions: IsActiveMatchOptions = {
    paths: 'subset',
    queryParams: 'subset',
    fragment: 'ignored',
    matrixParams: 'ignored'
  };

  constructor(private router: Router) {}


  isTheCurrentUrlActive(): boolean {
    if (!this.item.url) return false;
    return this.router.isActive(this.item.url, this.routerOptions);
  }
}
